import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export const IconChangePlan = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 21C16.4183 21 20 17.4183 20 13C20 8.58172 16.4183 5 12 5C7.58172 5 4 8.58172 4 13C4 17.4183 7.58172 21 12 21ZM11.2929 10.7071C10.9024 10.3166 10.9024 9.68342 11.2929 9.29289C11.6834 8.90237 12.3166 8.90237 12.7071 9.29289L15.7071 12.2929C16.0976 12.6834 16.0976 13.3166 15.7071 13.7071L12.7071 16.7071C12.3166 17.0976 11.6834 17.0976 11.2929 16.7071C10.9024 16.3166 10.9024 15.6834 11.2929 15.2929L12.5858 14H9C8.44772 14 8 13.5523 8 13C8 12.4477 8.44772 12 9 12H12.5858L11.2929 10.7071Z"
      fill="currentColor"
    />
  </SvgIcon>
)
